<template>
    <div>
        <div v-if="sortedUsers.length > 0" class="overflow-x-auto">
            <table class="min-w-full divide-y divide-gray-200">
                <thead class="bg-gray-50">
                    <tr>
                        <th 
                            class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider cursor-pointer hover:bg-gray-100 select-none w-1/4"
                            @click="sortBy('name')"
                        >
                            <div class="flex items-center space-x-1">
                                <span>Name</span>
                                <svg v-if="sortColumn === 'name'" 
                                     class="w-3 h-3 text-blue-600 -mt-0.5"
                                     fill="none" 
                                     stroke="currentColor" 
                                     viewBox="0 0 24 24"
                                >
                                    <path v-if="sortDirection === 'asc'"
                                          stroke-linecap="round" 
                                          stroke-linejoin="round" 
                                          stroke-width="2" 
                                          d="M5 15l7-7 7 7"
                                    />
                                    <path v-else
                                          stroke-linecap="round" 
                                          stroke-linejoin="round" 
                                          stroke-width="2" 
                                          d="M19 9l-7 7-7-7"
                                    />
                                </svg>
                                <span v-else class="w-3"></span>
                            </div>
                        </th>
                        <th 
                            class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider cursor-pointer hover:bg-gray-100 select-none w-1/4"
                            @click="sortBy('email')"
                        >
                            <div class="flex items-center space-x-1">
                                <span>Email</span>
                                <svg v-if="sortColumn === 'email'" 
                                     class="w-3 h-3 text-blue-600 -mt-0.5"
                                     fill="none" 
                                     stroke="currentColor" 
                                     viewBox="0 0 24 24"
                                >
                                    <path v-if="sortDirection === 'asc'"
                                          stroke-linecap="round" 
                                          stroke-linejoin="round" 
                                          stroke-width="2" 
                                          d="M5 15l7-7 7 7"
                                    />
                                    <path v-else
                                          stroke-linecap="round" 
                                          stroke-linejoin="round" 
                                          stroke-width="2" 
                                          d="M19 9l-7 7-7-7"
                                    />
                                </svg>
                                <span v-else class="w-3"></span>
                            </div>
                        </th>
                        <th 
                            class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider cursor-pointer hover:bg-gray-100 select-none w-1/4"
                            @click="sortBy('whats_app_number')"
                        >
                            <div class="flex items-center space-x-1">
                                <span>WhatsApp Number</span>
                                <svg v-if="sortColumn === 'whats_app_number'" 
                                     class="w-3 h-3 text-blue-600 -mt-0.5"
                                     fill="none" 
                                     stroke="currentColor" 
                                     viewBox="0 0 24 24"
                                >
                                    <path v-if="sortDirection === 'asc'"
                                          stroke-linecap="round" 
                                          stroke-linejoin="round" 
                                          stroke-width="2" 
                                          d="M5 15l7-7 7 7"
                                    />
                                    <path v-else
                                          stroke-linecap="round" 
                                          stroke-linejoin="round" 
                                          stroke-width="2" 
                                          d="M19 9l-7 7-7-7"
                                    />
                                </svg>
                                <span v-else class="w-3"></span>
                            </div>
                        </th>
                        <th 
                            class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider cursor-pointer hover:bg-gray-100 select-none w-1/4"
                            @click="sortBy('joined_whats_app_community_at')"
                        >
                            <div class="flex items-center space-x-1">
                                <span>Joined</span>
                                <svg v-if="sortColumn === 'joined_whats_app_community_at'" 
                                     class="w-3 h-3 text-blue-600 -mt-0.5"
                                     fill="none" 
                                     stroke="currentColor" 
                                     viewBox="0 0 24 24"
                                >
                                    <path v-if="sortDirection === 'asc'"
                                          stroke-linecap="round" 
                                          stroke-linejoin="round" 
                                          stroke-width="2" 
                                          d="M5 15l7-7 7 7"
                                    />
                                    <path v-else
                                          stroke-linecap="round" 
                                          stroke-linejoin="round" 
                                          stroke-width="2" 
                                          d="M19 9l-7 7-7-7"
                                    />
                                </svg>
                                <span v-else class="w-3"></span>
                            </div>
                        </th>
                    </tr>
                </thead>
                <tbody class="bg-white divide-y divide-gray-200">
                    <tr v-for="user in sortedUsers" :key="user.id">
                        <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{{ user.name }}</td>
                        <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{{ user.email }}</td>
                        <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{{ user.whats_app_number }}</td>
                        <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{{ formatDate(user.joined_whats_app_community_at) }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
        <p v-else class="text-gray-600 p-6">No WhatsApp community users found.</p>
    </div>
</template>

<script>
import { orderBy } from 'lodash';

export default {
    name: 'WhatsappUsersTable',

    props: {
        users: {
            type: Array,
            default: () => [],
        },
    },

    data() {
        return {
            sortColumn: 'joined_whats_app_community_at',
            sortDirection: 'desc',
        };
    },

    computed: {
        sortedUsers() {
            return orderBy(
                this.users,
                [this.sortColumn],
                [this.sortDirection]
            );
        },
    },

    methods: {
        sortBy(column) {
            if (this.sortColumn === column) {
                // Toggle direction if clicking the same column
                this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
            } else {
                // Set new column and default to ascending
                this.sortColumn = column;
                this.sortDirection = 'asc';
            }
            // Emit sort change event
            this.$emit('sort-changed', {
                column: this.sortColumn,
                direction: this.sortDirection,
            });
            // Also emit on the root Vue instance for cross-component communication
            if (this.$root && this.$root.$emit) {
                this.$root.$emit('whatsapp-users-sort-changed', {
                    column: this.sortColumn,
                    direction: this.sortDirection,
                });
            }
        },
        formatDate(dateString) {
            if (!dateString) {
                return '';
            }
            try {
                const date = new Date(dateString);
                if (isNaN(date.getTime())) {
                    return '';
                }
                const year = date.getFullYear();
                const month = String(date.getMonth() + 1).padStart(2, '0');
                const day = String(date.getDate()).padStart(2, '0');
                return `${year}-${month}-${day}`;
            } catch (e) {
                return '';
            }
        },
    },
};
</script>

